export class ObjectVcsError extends Error {
    constructor(message) {
        super(message);
        this.name = new.target.name;
    }
}
export class ValidationError extends ObjectVcsError {
    issues;
    constructor(message, issues) {
        super(message);
        this.issues = issues;
    }
}
export class RepositoryNotFoundError extends ObjectVcsError {
}
export class RepositoryAlreadyExistsError extends ObjectVcsError {
}
export class BranchNotFoundError extends ObjectVcsError {
}
export class BranchAlreadyExistsError extends ObjectVcsError {
}
export class EntityNotFoundError extends ObjectVcsError {
}
export class EntityAlreadyExistsError extends ObjectVcsError {
}
export class RevisionNotFoundError extends ObjectVcsError {
}
export class TagAlreadyExistsError extends ObjectVcsError {
}
export class TagNotFoundError extends ObjectVcsError {
}
export class TagRevisionMismatchError extends ObjectVcsError {
}
export class DirtyHeadError extends ObjectVcsError {
}
export class ConcurrencyConflictError extends ObjectVcsError {
}
export class PersistenceError extends ObjectVcsError {
}
export class SchemaCompatibilityError extends ObjectVcsError {
}
export class GarbageCollectionPlanStaleError extends ObjectVcsError {
}
export class GarbageCollectionUnsafeError extends ObjectVcsError {
}
export class GarbageCollectionPlanNotFoundError extends ObjectVcsError {
}
export class MigrationError extends ObjectVcsError {
    from;
    to;
    cause;
    constructor(message, details) {
        super(message);
        this.from = details.from;
        this.to = details.to;
        if (details.cause !== undefined) {
            this.cause = details.cause;
        }
    }
}
//# sourceMappingURL=errors.js.map